import React, {FC} from 'react';
import {useTranslation} from "react-i18next";

const defaultsStyles = {
    blockBgGradient: 'rgb(229, 229, 229)',
    titleColor: 'rgb(0, 90, 112)',
    buttonFont: 'rgb(19, 170, 158)'
}
interface JE {
    error: {
        code: number,
        message: string
    }
}
const JackpotError: FC <JE> = ({error}) => {
    const { t } = useTranslation();
    return (
        <div className="App">
            <header className="App-header" style={{
                backgroundColor: defaultsStyles.blockBgGradient,
                color: defaultsStyles.titleColor
            }}>
                {error.message}
                <p>
                    {t('notifications.titleCode')}: #{error.code} <br/>
                    <button onClick={() => { window.location.href = '/' }} style={{color:defaultsStyles.buttonFont}} className='btn bg-white mt-3'>{t('notifications.backToGames')}</button>
                </p>
                {
                    error.code === 104 ?
                        <p>
                            <a className='btn btn-success' onClick={() => {window.history.back()}}>{t('notifications.changeBet')}</a>
                            <br/>
                            <button onClick={() => { window.location.href = '/' }} className='btn bg-white text-dark mt-3'>{t('notifications.backToGames')}</button>
                        </p>
                        :null
                }

            </header>
        </div>
    );

}

export default JackpotError;
